export class CannotAccessDrive extends Error {
}

export class CannotOpenSession extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotOpenSession.name;
    }
}

export class NoVitaleCard extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = NoVitaleCard.name;
    }
}

export class NoCPXCard extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = NoCPXCard.name;
    }
}

export class WirelessConnectError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = WirelessConnectError.name;
    }
}

export class StellairAccessTokenError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = StellairAccessTokenError.name;
    }
}

export class StellairListTerminauxError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = StellairListTerminauxError.name;
    }
}

export class StellairHealthcareTokenError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = StellairHealthcareTokenError.name;
    }
}

export class MultipleVitaleCards extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.message = message;
        this.name = MultipleVitaleCards.name;
    }
}

export class MultipleCpxCards extends Error {
    public slots: Array<string>;
    constructor(slotsName: Array<string>, message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.message = message;
        this.name = MultipleCpxCards.name;
        this.slots = slotsName;
    }
}

export class VitaleCardRipped extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = VitaleCardRipped.name;
    }
}

export class CpxCardRipped extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CpxCardRipped.name;
    }
}

export class CannotReadVitale extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotReadVitale.name;
    }
}

export class CannotReadCpx extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotReadCpx.name;
    }
}

export class CpxCard extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CpxCard.name;
    }
}

export class TooManyPinCodeError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = TooManyPinCodeError.name;
    }
}

export class WrongPinCode extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = WrongPinCode.name;
    }
}

export class ExpiredCardError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = ExpiredCardError.name;
    }
}

export class UnauthorizedCpeCardError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = UnauthorizedCpeCardError.name;
    }
}
